import { createProvider } from './vue-apollo'

const ApolloProvider = createProvider();

export {ApolloProvider}